import {Component} from "@angular/core";

@Component({
    selector: "fui-attributed-list",
    styleUrls: ["./attributed-list.component.scss"],
    templateUrl: "./attributed-list.component.html"
})
export class FUIAttributedListComponent {
}
